import { api, ago, humanise, rupees } from '../api';
import { PageHead, Panel, ShortId, Table, useLoad } from '../ui';

export function Audit() {
  const { data, error, loading, reload } = useLoad(() => api.audit());
  const usage = useLoad(() => api.usage(7));

  return (
    <>
      <PageHead
        title="Audit"
        blurb="Every administrative action, newest first. This is the record of who approved whom."
      />

      <Panel
        title="Actions"
        right={
          <button className="btn sm" onClick={() => void reload()} disabled={loading}>
            Refresh
          </button>
        }
      >
        {error ? <div className="empty">{error}</div> : (
          <Table
            rows={data}
            keyOf={(a) => a.id}
            empty="Nothing recorded yet."
            columns={[
              { head: 'When', shrink: true, cell: (a) => ago(a.created_at) },
              { head: 'Who', shrink: true, cell: (a) => a.actor_name ?? 'system' },
              { head: 'Action', shrink: true, cell: (a) => <span className="mono">{a.action}</span> },
              { head: 'Entity', shrink: true, cell: (a) => a.entity },
              {
                head: 'Target',
                shrink: true,
                cell: (a) => (a.entity_id ? <ShortId id={a.entity_id} /> : '—'),
              },
              {
                head: 'Detail',
                cell: (a) =>
                  a.diff ? (
                    <span className="mono" style={{ color: 'var(--ink-soft)' }}>
                      {JSON.stringify(a.diff).slice(0, 110)}
                    </span>
                  ) : '—',
              },
            ]}
          />
        )}
      </Panel>

      <Panel title="Maps calls, last 7 days">
        <Table
          rows={usage.data}
          keyOf={(u) => `${u.sku}-${u.provider}`}
          empty="No calls logged."
          columns={[
            { head: 'Operation', cell: (u) => humanise(u.sku) },
            { head: 'Provider', shrink: true, cell: (u) => <span className="mono">{u.provider}</span> },
            { head: 'Calls', num: true, shrink: true, cell: (u) => u.calls },
            {
              head: 'From cache',
              num: true,
              shrink: true,
              cell: (u) => (u.cache_hit_pct == null ? '—' : `${u.cache_hit_pct}%`),
            },
            { head: 'Cost', num: true, shrink: true, cell: (u) => rupees(u.cost_paise) },
          ]}
        />
      </Panel>
    </>
  );
}
